// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

import { useState } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { useModal } from 'hooks';
import Info from './Info';
import Preferences, { OverlayAdapter } from './Preferences';
import { loadPreferences, savePreferences, hasPreferences } from 'common/gdpr-storage';
import Cookie from 'common/cookie';

import COOKIE_POLICY_QUERY from 'queries/CookiePolicy.graphql';

const CookiePolicy = ({ layoutType = undefined }) => {
    const [isInfoVisible, setInfoVisible] = useState(() => !hasPreferences());
    const [isPreferencesVisible, setPreferencesVisible] = useModal('cookie-policy-preferences');
    const [preferences, setPreferences] = useState(loadPreferences);

    const { data: { config } = {} } = useQuery(COOKIE_POLICY_QUERY);

    const handleSave = nextPreferences => {
        setInfoVisible(false);
        setPreferences(nextPreferences);
        savePreferences(nextPreferences);
        config.gdpr.cookies.forEach(({ name, type }) => {
            if (nextPreferences[type] === false) {
                Cookie.remove(name, '/');
            }
        });
    };

    return (
        <>
            {config?.gdpr?.cookieBox?.enabled && isInfoVisible && (
                <Info
                    onSave={handleSave}
                    onPreferencesToggle={setPreferencesVisible}
                    contentAlignment={layoutType === 'simplified' ? 'center' : undefined}
                />
            )}
            <Preferences
                isOpen={isPreferencesVisible !== null}
                preferences={preferences}
                onSave={handleSave}
                onToggle={setPreferencesVisible}
                adapter={layoutType === 'simplified' ? OverlayAdapter : undefined}
            />
        </>
    );
};

CookiePolicy.propTypes = {
    layoutType: PropTypes.oneOf(['simplified']),
};

export default CookiePolicy;
